import { HttpErrorResponse } from '@angular/common/http';
import { CallState, SipState } from '@main/models/sip-state';
import { Action } from '@ngrx/store';
import { CallGetRequest } from '@services/associations/model/callGetRequest';
import { PageCallResponse } from '@services/associations/model/pageCallResponse';
import { PageManagerEventResponse } from '@services/associations/model/pageManagerEventResponse';
import { MinimizedDialogInfoModel } from '@shared/models/minimized-dialog-info.model';
import { PaginationModel } from '@shared/models/pagination.model';

export enum MainActionTypes {
  MinimizeDialog = '[Main] Minimize Dialog',
  RestoreMinimizedDialog = '[Main] Restore Minimized Dialog',
  CloseMinimizedDialog = '[Main] Close Minimized Dialog',
  ChangeSipState = '[Main] Change SIP State',
  ChangeCallState = '[Main] Change call State',
  ResetCallState = '[Main] Reset call State',
  ProceedCall = '[Main] Proceed call',
  GetCallsList = '[Main] Get Calls List',
  GetCallsListSuccess = '[Main] Get Calls List Success',
  GetCallsListFailure = '[Main] Get Calls List Failure',
  ChangeCallsListPage = '[Main] Change Call List Page',
  GetNotificationsList = '[Main] Get Notifications List',
  GetNotificationsListSuccess = '[Main] Get Notifications List Success',
  GetNotificationsListFailure = '[Main] Get Notifications List Failure',
  ChangeNotificationsListPage = '[Main] Change Notifications List Page',
  SetInitialState = '[Main] Set Initial State',
}

/** Minimize, Restore, Close Dialog */
export class MinimizeDialog implements Action {
  readonly type = MainActionTypes.MinimizeDialog;
  constructor(public payload: MinimizedDialogInfoModel) { }
}

export class RestoreMinimizedDialog implements Action {
  readonly type = MainActionTypes.RestoreMinimizedDialog;
  constructor(public payload: string) { }
}

export class CloseMinimizedDialog implements Action {
  readonly type = MainActionTypes.CloseMinimizedDialog;
  constructor(public payload: string) { }
}

/** Sip State */
export class ChangeSipState implements Action {
  readonly type = MainActionTypes.ChangeSipState;
  constructor(public payload: SipState) { }
}

export class ChangeCallState implements Action {
  readonly type = MainActionTypes.ChangeCallState;
  constructor(public payload: CallState) { }
}

export class ResetCallState implements Action {
  readonly type = MainActionTypes.ResetCallState;
  constructor() { }
}

export class ProceedCall implements Action {
  readonly type = MainActionTypes.ProceedCall;
  constructor(public payload: {command: string, number?: string}) { }
}

/** Get Calls List */
export class GetCallsList implements Action {
  readonly type = MainActionTypes.GetCallsList;
  constructor(public payload: {request: CallGetRequest, mergeItems?: boolean}) { }
}

export class GetCallsListSuccess implements Action {
  readonly type = MainActionTypes.GetCallsListSuccess;
  constructor(public payload: {response: PageCallResponse, mergeItems?: boolean}) { }
}

export class GetCallsListFailure implements Action {
  readonly type = MainActionTypes.GetCallsListFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Change Calls List Page */
export class ChangeCallsListPage implements Action {
  readonly type = MainActionTypes.ChangeCallsListPage;
  constructor(public payload: PaginationModel) { }
}

/** Get User Notifications List */
export class GetNotificationsList implements Action {
  readonly type = MainActionTypes.GetNotificationsList;
  constructor(public payload: {request?: any, mergeItems?: boolean}) { }
}

export class GetNotificationsListSuccess implements Action {
  readonly type = MainActionTypes.GetNotificationsListSuccess;
  constructor(public payload: {response: PageManagerEventResponse, mergeItems?: boolean}) { }
}

export class GetNotificationsListFailure implements Action {
  readonly type = MainActionTypes.GetNotificationsListFailure;
  constructor(public payload: HttpErrorResponse) { }
}

export class ChangeNotificationsListPage implements Action {
  readonly type = MainActionTypes.ChangeNotificationsListPage;
  constructor(public payload: PaginationModel) { }
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = MainActionTypes.SetInitialState;
}

export type MainActions =
  | MinimizeDialog
  | RestoreMinimizedDialog
  | CloseMinimizedDialog
  | ChangeSipState
  | ChangeCallState
  | ResetCallState
  | ProceedCall
  | GetCallsList
  | GetCallsListSuccess
  | GetCallsListFailure
  | ChangeCallsListPage
  | GetNotificationsList
  | GetNotificationsListSuccess
  | GetNotificationsListFailure
  | ChangeNotificationsListPage
  | SetInitialState
  ;

